import * as React from 'react';

import * as state from '@rematter/modules/customer-portal/_state/bookingList.state';
import { useAtomValue } from 'jotai';

import { InvoiceRecord } from '../_graphql/queryInvoices';

export const useInvoicesByBookings = (bookingIds: string[]) => {
  const [invoices, setInvoices] = React.useState<InvoiceRecord[]>([]);

  const { fetch: fetchInvoiceIds } = useAtomValue(state.$invoiceIdsByBooking);
  const { fetch: fetchInvoices } = useAtomValue(state.$invoices);

  React.useEffect(() => {
    if (!bookingIds.length) {
      return setInvoices([]);
    }

    fetchInvoiceIds({
      bookingIds,
    }).then(async (invoiceIds) => {
      if (!invoiceIds.length) {
        return setInvoices([]);
      }

      const invoices = await fetchInvoices({ invoiceIds });

      setInvoices(invoices);
    });
  }, [bookingIds, fetchInvoiceIds, fetchInvoices]);

  return invoices;
};
